type ImageSize = {
  width: number;
  height: number;
};

export const getLocalImageSize = async (file: File): Promise<ImageSize> => {
  const img = new Image();
  img.src = URL.createObjectURL(file);
  const cleanup = () => {
    try {
      URL.revokeObjectURL(img.src);
    } catch (error) {
      console.warn(`Failed to revoke URL during validation:`, error);
    }
  };
  return new Promise((resolve) => {
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      cleanup();
    };
    img.onerror = () => {
      resolve({ width: 0, height: 0 });
      cleanup();
    };
  });
};
